import { useState } from "react";
import { toast } from "react-hot-toast";
import { useBrand } from '../../Context/Brand/BrandContext';

export default function NameForm({ onNameSubmit, processing }) {
  const { brand } = useBrand();
  const accentColor = brand.primaryColor || '#1A7F6D';
  const [name, setName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) {
      toast.error('Please enter your name');
      return;
    }
    if (trimmed.length < 2) {
      toast.error('Name must be at least 2 characters');
      return;
    }
    onNameSubmit(trimmed);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-[13px] font-semibold text-neutral-600 mb-2">
          Your name
        </label>
        <input
          name="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Amina"
          autoFocus
          className="w-full h-11 px-4 rounded-2xl border border-neutral-200 bg-neutral-50 text-[15px] text-neutral-900 placeholder:text-neutral-300 focus:outline-none focus:border-neutral-400 focus:bg-white transition-colors"
        />
      </div>
      <button
        type="submit"
        disabled={processing}
        className="w-full h-11 rounded-2xl text-white text-sm font-semibold hover:opacity-90 active:scale-[0.99] disabled:opacity-40 disabled:active:scale-100 transition"
        style={{ backgroundColor: accentColor }}
      >
        {processing ? (
          <span className="flex items-center justify-center gap-2">
            <span className="w-4 h-4 rounded-full border-2 border-white/20 border-t-white animate-spin" />
          </span>
        ) : (
          'Continue'
        )}
      </button>
    </form>
  );
}
